import { render, staticRenderFns } from "./ActionTypeEdit.vue?vue&type=template&id=647f797e&scoped=true"
import script from "./ActionTypeEdit.vue?vue&type=script&lang=js"
export * from "./ActionTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./ActionTypeEdit.vue?vue&type=style&index=0&id=647f797e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f797e",
  null
  
)

export default component.exports